import type { CSSProperties } from "react";

/** The self-hosted Phosphor icons we use, by simple name. */
export type IconName =
  | "bank"
  | "credit-card"
  | "money-wavy"
  | "receipt"
  | "calendar-dot"
  | "piggy-bank"
  | "storefront"
  | "plus"
  | "stack"
  | "gear"
  | "sign-out"
  | "sun"
  | "moon"
  | "download";

interface Props {
  name: IconName;
  /** Size in pixels. */
  size?: number;
  className?: string;
}

/**
 * Render a self-hosted SVG icon via a CSS mask so it takes the current text
 * colour (works across both themes). The SVG files live in /public/icons.
 */
export function Icon({ name, size = 20, className }: Props) {
  const url = `/icons/${name}.svg`;
  const style: CSSProperties = {
    display: "inline-block",
    width: size,
    height: size,
    backgroundColor: "currentColor",
    maskImage: `url(${url})`,
    WebkitMaskImage: `url(${url})`,
    maskRepeat: "no-repeat",
    WebkitMaskRepeat: "no-repeat",
    maskPosition: "center",
    WebkitMaskPosition: "center",
    maskSize: "contain",
    WebkitMaskSize: "contain",
    flexShrink: 0,
  };
  return <span aria-hidden role="img" className={className} style={style} />;
}
